import React, { Component } from 'react'
import { observer } from 'mobx-react'

@observer(['globals'])
export default class Logout extends Component {
  constructor(props) {
    super(props)

    this.props.globals.logout()
  }

  render() {
    return (
      <div className="footer">
        <span>LOGOUT</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/logout.js